import firstStepIcon from '../../../../assets/images/reg-guide/logo-vertical.svg';
import secondStepIcon from '../../../../assets/images/reg-guide/step-2.png';
import thirdStepIcon from '../../../../assets/images/reg-guide/step-3.png';
import iconFirst from '../../../../assets/images/reg-guide/child-first.jpg';
import iconSecond from '../../../../assets/images/reg-guide/child-second.png';

export const adultSteps = [{
  title: 'regGuide.ecp.step1.title',
  description: 'regGuide.ecp.step1.description',
  icon: firstStepIcon,
  actionHref: 'regGuide.step1.action.href',
  actionContent: 'regGuide.ecp.step1.action',
  index: 1,
}, {
  title: 'regGuide.ecp.step2.title',
  description: 'regGuide.ecp.step2.description',
  list: ['regGuide.ecp.step2.item-1', 'regGuide.ecp.step2.item-2'],
  isList: true,
  icon: secondStepIcon,
  actionContent: 'regGuide.step2.action',
  index: 2,
}, {
  title: 'regGuide.step3.title',
  description: 'regGuide.step3.description',
  icon: thirdStepIcon,
  index: 3,
}];

export const childSteps = [{
  title: 'regGuide.childSteps.step-1.title',
  description: 'regGuide.childSteps.step-1.description',
  actionHref: 'regGuide.step1.action.href',
  actionContent: 'regGuide.ecp.step1.action',
  index: 1,
}, {
  title: 'regGuide.childSteps.step-2.title',
  list: ['regGuide.childSteps.step-2.item-1', 'regGuide.childSteps.step-2.item-2'],
  iconFirst,
  iconSecond,
  isList: true,
  index: 2,
}, {
  title: 'regGuide.childSteps.step-3.title',
  list: ['regGuide.childSteps.step-3.item-1', 'regGuide.childSteps.step-3.item-2', 'regGuide.childSteps.step-3.item-3'],
  isList: true,
  index: 3,
}];
